import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MMPptxViewerComponent } from './mm-pptx-viewer.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MMPptxViewerComponent],
  exports: [MMPptxViewerComponent],
})
export class MMPptxViewerModule {}
